import {
  Button,
  IconButton,
  Paper,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
  SwipeableDrawer
} from '@rabex-kit/rabex-ui';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import {
  GenericBurgerRegular,
  OtherMoon,
  OtherSun,
  SoftwareDownload
} from '@heathmont/moon-icons-tw';
import Logo from '../../static/images/svg/HeaderLogoLight.svg';
import DarkLogo from '../../static/images/svg/Logo-dark.svg';
import Qrcode2 from '../../static/images/svg/RabexQrCode.svg';
import AndroidLogo from '../../static/images/svg/AndroidLogo.svg?react';
import CustomPopover from '../Popover';
import Icon from '../Icon';
import {
  DASHBOARD,
  LOGIN,
  MARKETS,
  OTC,
  P2P_STATIC,
  REGISTER
} from '@/pages/routes';
import AuthDrawerMenu from './AuthDrawerMenu';
import { MuiThemeContext } from '@/MuiTheme';
import { useBackButtonClose } from '@/hooks/useBackButtonClose';

// Types for header props
interface HeaderProps {
  // eslint-disable-next-line react/no-unused-prop-types
  showBackButton?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  backUrl?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  title?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  showMenuButton?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  onMenuToggle?: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  sideBarMode?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  hasDesktopHeader?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  hasMobileHeader?: boolean;
}

// Desktop Header Component (unchanged)
const DesktopHeader = () => {
  const theme = useTheme();
  const { palette } = theme;
  const location = useLocation();
  const navigate = useNavigate();
  const muiTheme = React.useContext(MuiThemeContext);

  return (
    <Stack
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
      py={3}
      px={6}
      height={64}>
      <Stack alignItems="center" flexDirection="row">
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ cursor: 'pointer' }}
          onClick={() => navigate(DASHBOARD)}>
          <img
            src={palette.mode === 'light' ? Logo : DarkLogo}
            alt="logo"
            height={40}
            style={{ marginLeft: 12 }}
          />
        </Stack>
        <Stack flexDirection="row" alignItems="center" gap={3}>
          {/* <a href={`${P2P_STATIC}/USDTTMN`}>
            <Stack
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              py={2}
              px={3}
              height={40}
              gap={1.5}>
              <Typography color="textColor.A80" variant="body2">
                معامله
              </Typography>
              <Icon size={16}>
                <ControlsChevronDown />
              </Icon>
            </Stack>
          </a> */}
          {/* <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            py={2}
            px={3}
            height={40}>
            <a href={OTC}>
              <Typography variant="body2">تبدیل سریع</Typography>
            </a>
          </Stack> */}

          {/*     <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            py={2}
            px={3}
            height={40}>
            <a href={MARKETS}>
              <Typography variant="body2">قیمت ارز دیجیتال</Typography>
            </a>
          </Stack> */}

          {/*  <a href="">
            <Stack
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              py={2}
              px={3}
              height={40}
              gap={1.5}>
              <Typography color="textColor.A80" variant="body2">
                راب‌ایکس
              </Typography>
              <Icon size={16}>
                <ControlsChevronDown />
              </Icon>
            </Stack>
          </a> */}
          {/* <a href="">
            <Stack
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              py={2}
              px={3}
              height={40}
              gap={1.5}>
              <Typography color="textColor.A80" variant="body2">
                آموزش
              </Typography>
              <Icon size={16}>
                <ControlsChevronDown />
              </Icon>
            </Stack>
          </a> */}
        </Stack>
      </Stack>

      <Stack flexDirection="row-reverse" alignItems="center" gap={4}>
        <Stack flexDirection="row-reverse" gap={4} alignItems="center">
          <Stack>
            <CustomPopover
              placement="bottom"
              button={
                <Stack>
                  <IconButton
                    size="md"
                    variant="circular"
                    hasBg
                    bgColor={palette.secondary[500]}>
                    <Icon>
                      <SoftwareDownload />
                    </Icon>
                  </IconButton>
                </Stack>
              }>
              <Paper elevation={14} sx={{ borderRadius: 4 }}>
                <Stack
                  gap={3}
                  sx={{ p: 4, alignItems: 'center', justifyContent: 'center' }}>
                  <img
                    src={Qrcode2}
                    width={146}
                    height={146}
                    alt="qrcode"
                    style={{
                      border: `4px solid ${palette.secondary.A100}`,
                      borderRadius: 8
                    }}
                  />
                  <a
                    href="https://rabex.ir/download/"
                    title="نسخه اندروید"
                    target="_blank"
                    rel="noreferrer">
                    <Stack
                      direction="row"
                      gap={1.5}
                      alignItems="center"
                      justifyContent="center"
                      sx={{ cursor: 'pointer' }}>
                      <Icon>
                        <AndroidLogo />
                      </Icon>
                      <Typography
                        variant="body3"
                        weight="bold"
                        color={palette.textColor[900]}>
                        دانلود نسخه اندروید
                      </Typography>
                    </Stack>
                  </a>
                </Stack>
              </Paper>
            </CustomPopover>
          </Stack>
          <Stack>
            <IconButton
              onClick={() => muiTheme.toggleColorMode()}
              size="md"
              variant="circular"
              hasBg
              bgColor={palette.secondary[500]}>
              <Icon>
                {theme.palette.mode === 'light' ? <OtherSun /> : <OtherMoon />}
              </Icon>
            </IconButton>
          </Stack>
        </Stack>

        <Stack flexDirection="row" height={40} gap={4}>
          <Button
            variant="containedSecondary"
            size="md"
            onClick={() => navigate(LOGIN)}>
            ورود
          </Button>
          <Button
            sx={{ width: '100px' }}
            variant="contained"
            size="md"
            onClick={() => navigate(REGISTER)}>
            ثبت نام
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

// Enhanced Mobile Header Component
const MobileHeader = ({ showMenuButton = true, onMenuToggle }: HeaderProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { palette } = theme;
  const muiTheme = React.useContext(MuiThemeContext);

  // Get state from location.state

  return (
    <Stack
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
      py={3}
      px={4}
      position="fixed"
      left={0}
      right={0}
      top={0}
      zIndex={1000}
      height={56}
      bgcolor={palette.base[50]}>
      {/* Left section - Hamburger Menu + Logo */}
      <Stack alignItems="center" flexDirection="row">
        {/* Hamburger Menu Button */}
        {showMenuButton && (
          <Icon size={32} onClick={onMenuToggle}>
            <GenericBurgerRegular />
          </Icon>
        )}

        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ cursor: 'pointer' }}
          onClick={() => navigate(DASHBOARD)}>
          <img
            src={theme.palette.mode === 'light' ? Logo : DarkLogo}
            alt="logo"
            height={32}
            width={111}
            style={{ marginLeft: showMenuButton ? 0 : 8 }}
          />
        </Stack>
      </Stack>
      {/* Right section - User actions */}
      <Stack flexDirection="row-reverse" alignItems="center" gap={2}>
        <Stack
          width={32}
          height={32}
          justifyContent="center"
          alignItems="center"
          p={1}
          onClick={() => muiTheme.toggleColorMode()}>
          <Icon size={24}>
            {theme.palette.mode === 'light' ? <OtherSun /> : <OtherMoon />}
          </Icon>
        </Stack>
        <Button
          variant="contained"
          size="sm"
          sx={{ width: '72px' }}
          onClick={() => navigate(REGISTER)}>
          ثبت نام
        </Button>
        <Button
          variant="containedSecondary"
          size="sm"
          sx={{ width: '72px' }}
          onClick={() => navigate(LOGIN)}>
          ورود
        </Button>
      </Stack>
    </Stack>
  );
};

const MobileNavigationDrawer = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { palette } = useTheme();

  // Android back button dismisses the drawer instead of navigating away from the page.
  useBackButtonClose(open, onClose);

  return (
    <SwipeableDrawer
      keepMounted
      anchor="top"
      open={open}
      onOpen={() => null}
      onClose={onClose}
      swipeAreaWidth={0}
      disableSwipeToOpen={false}
      PaperProps={{
        sx: {
          borderRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0
        }
      }}>
      <AuthDrawerMenu onClose={onClose} />
    </SwipeableDrawer>
  );
};

// Main Header Component with fixed responsive logic
const AuthHeader = (props: HeaderProps) => {
  const theme = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const handleMenuToggle = () => {
    setMobileMenuOpen((prev) => !prev);
    props.onMenuToggle?.();
  };

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          gridArea: 'header',
          borderRadius: 0,
          position: 'relative',
          zIndex: 1000,
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.base[50]
              : theme.palette.base[200]
        }}>
        {!isMobile ? (
          <DesktopHeader />
        ) : (
          <MobileHeader {...props} onMenuToggle={handleMenuToggle} />
        )}
      </Paper>
      {/* Mobile Navigation Drawer - only show on mobile */}
      {isMobile && (
        <MobileNavigationDrawer
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default AuthHeader;
